import React from "react";
import { pillars } from "../data/mock";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const WhatWeDo = () => (
  <div>
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-16">
      <div className="section-eyebrow text-[#0d2a20]/60 mb-6">What we do</div>
      <h1 className="hero-title text-[46px] md:text-[84px] leading-[1] max-w-[1200px]">Three levers. <span className="font-serif-i text-[#e0684d]">One outcome.</span></h1>
      <p className="mt-8 max-w-[820px] text-[17px] leading-relaxed text-[#0d2a20]/80">We don&rsquo;t start new programmes. We strengthen the ones already changing lives — with consultancy, diaspora expertise, and physical resources.</p>
    </section>

    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24 space-y-24">
      {pillars.map((p, i) => (
        <div key={i} className={`grid md:grid-cols-2 gap-10 items-center ${i % 2 ? 'md:[&>*:first-child]:order-2' : ''}`}>
          <div className="rounded-lg overflow-hidden"><img src={p.img} alt={p.title} className="w-full h-[420px] object-cover" /></div>
          <div>
            <div className="font-serif-i text-[#e0684d] text-[48px] mb-2">{p.roman}</div>
            <h2 className="hero-title text-[40px] md:text-[56px] leading-tight mb-6">{p.title}</h2>
            <p className="text-[16px] leading-relaxed text-[#0d2a20]/80 max-w-[520px]">{p.desc}</p>
          </div>
        </div>
      ))}
    </section>

    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
      <div className="rounded-lg p-10 md:p-16" style={{ background: '#0f3d2e', color: '#f4efe4' }}>
        <h3 className="hero-title text-[36px] md:text-[52px] leading-tight max-w-[900px]">Ready to be strengthened? <span className="font-serif-i text-[#e0684d]">Let&rsquo;s talk.</span></h3>
        <Link to="/apply-for-support" className="inline-flex items-center gap-2 mt-8 px-5 py-3 rounded-md btn-coral text-[14px]">Apply for support <ArrowUpRight size={16} /></Link>
      </div>
    </section>
  </div>
);

export default WhatWeDo;
